<template>
  <el-table size="mini" :data="data" class="table" border>
    <el-table-column
      v-for="(h, idx) in columns"
      :key="idx"
      :prop="`month-${idx === 0 ? 'header' : idx}`"
      :label="h"
      :min-width="$lange == 'en' ? 100:60"
      show-overflow-tooltip
    ></el-table-column>
  </el-table>
</template>

<script>
const MonthHeader = [
  "状态",
  "一月",
  "二月",
  "三月",
  "四月",
  "五月",
  "六月",
  "七月",
  "八月",
  "九月",
  "十月",
  "十一月",
  "十二月",
];

export default {
  name: "MonthRowTable",
  props: {
    data: {
      type: Array,
    },
  },
  data() {
    return {
      // columns: Object.freeze(MonthHeader),
      columns: [
        this.$lange == "en" ? "Status" : "状态",
        this.$lange == "en" ? "Jan" : "一月",
        this.$lange == "en" ? "Feb" : "二月",
        this.$lange == "en" ? "Mar" : "三月",
        this.$lange == "en" ? "Apr" : "四月",
        this.$lange == "en" ? "May" : "五月",
        this.$lange == "en" ? "Jun" : "六月",
        this.$lange == "en" ? "Jul" : "七月",
        this.$lange == "en" ? "Aug" : "八月",
        this.$lange == "en" ? "Sep" : "九月",
        this.$lange == "en" ? "Oct" : "十月",
        this.$lange == "en" ? "Nov" : "十一月",
        this.$lange == "en" ? "Dec" : "十二月",
      ],
    };
  },
};
</script>

<style scoped>
.table {
  border: 1px solid rgb(167, 164, 164);
}

.el-table ::v-deep th.el-table__cell.is-leaf,
.el-table ::v-deep td.el-table__cell {
  border-bottom: 1px solid rgb(167, 164, 164);
  border-right: 1px solid rgb(167, 164, 164);
}
</style>
